export const RETAIL_HEADER = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.RetailHeaderWidgetElement';
